module.exports = __webpack_public_path__ + "static/img/shibanmushi_ka.ddc28d0.jpg";